import { chat } from "@/lib/http";

export interface PendingInvitation {
  id: string;
  token: string;
  account_id: string;
  account_name: string;
  role: string;
  created_at: string;
  expires_at: string | null;
}

export function getPendingInvitations() {
  return chat<PendingInvitation[]>("/v1/chat/invitations");
}

export function acceptInvitation(token: string) {
  return chat<{ user_id: string; account_id: string; role: string }>(
    `/v1/chat/invitations/${token}`,
    { method: "PATCH" },
  );
}
